






















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { BusEvent, BusEventTargets } from '../../containers/globals/BusEvent';

@Component
export default class ConfirmationDialog extends Vue {
  @Prop()
  private bootEventType!: BusEventTargets;

  private confirmationdialog: boolean = false;

  public created(): void {
    BusEvent.$on(this.bootEventType, (value: boolean) => {
      this.confirmationdialog = value;
    });
  }

  @Emit('confirmation-dialog-ok')
  private confirmationDialogOK(): void {
    this.confirmationdialog = false;
  }

  @Emit('confirmation-dialog-cancel')
  private confirmationDialogCancel(): void {
    this.confirmationdialog = false;
  }
}
